// Generates and prints an i3 Radiology training certificate as a browser print/save-as-PDF dialog.
export function printCertificate(cert) {
  const w = window.open('', '_blank');
  const escaped = {
    user_name: escapeHtml(cert.user_name),
    module_title: escapeHtml(cert.module_title),
    module_subtitle: escapeHtml(cert.module_subtitle || ''),
    completed_on: escapeHtml(formatDate(cert.completed_on)),
    issued_at: escapeHtml(formatDate(cert.issued_at)),
    certificate_id: escapeHtml(cert.certificate_id),
    practice: escapeHtml(cert.practice),
    steps: cert.total_steps,
  };
  const html = `<!DOCTYPE html>
<html><head><title>Certificate — ${escaped.module_title}</title>
<style>
  @page { size: A4 landscape; margin: 0; }
  * { box-sizing: border-box; }
  body { margin: 0; font-family: 'Georgia', 'Times New Roman', serif; background: #f8fafc; color: #0E2D5C; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
  .cert {
    width: 297mm; min-height: 210mm; margin: 0 auto; padding: 24mm 30mm;
    background: linear-gradient(135deg, #ffffff 0%, #f0fafb 100%);
    border: 18px double #0E2D5C; position: relative; display: flex; flex-direction: column;
  }
  .inner-border { position: absolute; inset: 16px; border: 2px solid #42CDD7; pointer-events: none; }
  .watermark { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; opacity: 0.04; pointer-events: none; font-size: 280px; font-weight: 900; color: #42CDD7; font-family: 'Outfit', sans-serif; letter-spacing: 8px; }
  .brand { text-align: center; position: relative; z-index: 2; }
  .brand-name { font-family: 'Georgia', serif; font-size: 22px; color: #0E2D5C; font-weight: bold; letter-spacing: 2px; }
  .brand-sub { font-size: 11px; color: #64748B; text-transform: uppercase; letter-spacing: 3px; margin-top: 4px; }
  .separator { width: 80px; height: 3px; background: #42CDD7; margin: 18px auto; }
  .title { text-align: center; font-size: 44px; font-weight: bold; color: #0E2D5C; margin: 20px 0 8px; letter-spacing: 2px; position: relative; z-index: 2; }
  .subtitle { text-align: center; font-size: 13px; color: #64748B; text-transform: uppercase; letter-spacing: 6px; margin-bottom: 32px; position: relative; z-index: 2; }
  .presented { text-align: center; font-size: 14px; color: #475569; font-style: italic; position: relative; z-index: 2; }
  .recipient { text-align: center; font-size: 56px; font-family: 'Georgia', serif; color: #0E2D5C; font-weight: 500; margin: 18px 0; padding-bottom: 14px; border-bottom: 2px solid #42CDD7; display: inline-block; min-width: 50%; position: relative; z-index: 2; }
  .recipient-wrap { text-align: center; position: relative; z-index: 2; }
  .body-text { text-align: center; font-size: 15px; color: #334155; line-height: 1.8; margin: 28px auto; max-width: 600px; position: relative; z-index: 2; }
  .module-name { font-weight: bold; color: #2563EB; font-size: 17px; }
  .footer { display: flex; justify-content: space-between; align-items: flex-end; margin-top: auto; padding-top: 24px; border-top: 1px solid #cbd5e1; position: relative; z-index: 2; }
  .sig-block { text-align: center; flex: 1; }
  .sig-line { border-top: 1.5px solid #0E2D5C; margin: 0 20px 8px; padding-top: 6px; font-size: 11px; color: #64748B; text-transform: uppercase; letter-spacing: 1.5px; font-weight: 600; }
  .sig-sub { font-size: 10px; color: #94a3b8; font-style: italic; }
  .seal { width: 100px; height: 100px; border-radius: 50%; background: radial-gradient(circle, #42CDD7 0%, #0E2D5C 100%); display: flex; align-items: center; justify-content: center; color: white; font-family: 'Outfit', sans-serif; font-weight: bold; font-size: 10px; text-align: center; line-height: 1.2; letter-spacing: 1px; box-shadow: 0 4px 12px rgba(14,45,92,0.3); flex-shrink: 0; }
  .cert-id { text-align: center; font-size: 9px; color: #94a3b8; margin-top: 12px; font-family: 'JetBrains Mono', monospace; letter-spacing: 1px; position: relative; z-index: 2; }
  .no-print-toolbar { position: fixed; top: 16px; right: 16px; display: flex; gap: 8px; z-index: 100; }
  .no-print-toolbar button { padding: 10px 20px; font-family: Arial, sans-serif; font-size: 13px; border: none; border-radius: 8px; cursor: pointer; font-weight: 600; box-shadow: 0 2px 8px rgba(0,0,0,0.15); }
  .btn-print { background: #42CDD7; color: white; }
  .btn-close { background: #f1f5f9; color: #475569; }
  @media print { .no-print-toolbar { display: none !important; } body { background: white; } .cert { border-width: 12px; } }
</style>
</head><body>
  <div class="no-print-toolbar">
    <button class="btn-print" onclick="window.print()">Save as PDF / Print</button>
    <button class="btn-close" onclick="window.close()">Close</button>
  </div>
  <div class="cert">
    <div class="inner-border"></div>
    <div class="watermark">i3</div>
    <div class="brand">
      <div class="brand-name">i3 RADIOLOGY</div>
      <div class="brand-sub">Infinity Imaging &amp; Interventions</div>
      <div class="separator"></div>
    </div>
    <h1 class="title">Certificate of Completion</h1>
    <div class="subtitle">Kestral Karisma K4 Training</div>
    <div class="presented">This is to certify that</div>
    <div class="recipient-wrap"><div class="recipient">${escaped.user_name}</div></div>
    <p class="body-text">
      has successfully completed all <strong>${escaped.steps}</strong> training steps of the module<br/>
      <span class="module-name">${escaped.module_title}</span><br/>
      <em style="font-size:12px;color:#64748B">${escaped.module_subtitle}</em>
    </p>
    <div class="footer">
      <div class="sig-block">
        <div class="sig-line">Date of Completion</div>
        <div class="sig-sub">${escaped.completed_on}</div>
      </div>
      <div class="seal">i3<br/>VERIFIED<br/>TRAINING</div>
      <div class="sig-block">
        <div class="sig-line">${escaped.practice}</div>
        <div class="sig-sub">Issued ${escaped.issued_at}</div>
      </div>
    </div>
    <div class="cert-id">Certificate ID: ${escaped.certificate_id}</div>
  </div>
</body></html>`;
  w.document.write(html);
  w.document.close();
}

function escapeHtml(s) {
  return String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

function formatDate(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  return d.toLocaleDateString('en-AU', { year: 'numeric', month: 'long', day: 'numeric' });
}
